<template>
	<sf-search-layout>
		<el-row :gutter="20">
			<el-col :span="4">
				<sf-select-group
					:label="getMessage_('SWCC000586')"
					:inputValue="plantCd"
					:options="plants"
					:onChange="value => onChange({ key: 'plantCd', value })"
				/>
			</el-col>
			<el-col :span="4">
				<sf-select-group
					:label="getMessage_('SWCC000248')"
					:inputValue="shopCd"
					:options="shopCds"
					:onChange="value => onChange({ key: 'shopCd', value })"
				/>
			</el-col>
			<el-col :span="4">
				<sf-select-group
					:label="getMessage_('SWCC000587')"
					:inputValue="stnCd"
					:options="stnCds"
					:onChange="value => onChange({ key: 'stnCd', value })"
				/>
			</el-col>
		</el-row>
		<template slot="button">
			<sf-button line icon="search" :v-if="isButton_(scrId, 'CR')" :onClick="search">{{ getMessage_('SWCC000244') }}</sf-button>
		</template>
	</sf-search-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/RegisterReportingPoint/store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			plantCd: '',
			shopCd: '',
			stnCd: '',
			pageInit: true,
			screen: {}
		};
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	watch: {
		//화면 정보 로딩시
		screen() {
			if (this.pageInit && this.screen.defaultPageSize && this.user.plantCd) {
				this.SET_STATE({ key: 'searchParams', value: { ...this.searchParams, ['plantCd']: this.user.plantCd } });
				this.plantCd = this.user.plantCd;

				this.setState_({
					key: 'stations',
					value: { currentPage: 1, pageUnit: this.screen.defaultPageSize, data: [] }
				})
					.then(() => {
						this.pageInit = false;

						if (this.$route.query.stnCd != null) {
							this.SET_STATE({ key: 'searchParams', value: { ...this.searchParams, ['stnCd']: this.$route.query.stnCd } });
							this.stnCd = this.$route.query.stnCd;
						}

						this.getCommCds_({ key: 'flags', commCdType: 'FLG_TYPE' }).then(() => this.search());
						this.getPlants_();
						this.getCommCds_({ key: 'shopCds', commCdType: 'SHOP' });
						this.getCommCds_({ key: 'cids', commCdType: 'CID' });
						this.getCommCds_({ key: 'hids', commCdType: 'HID' });
						this.getCommCds_({ key: 'lines', commCdType: 'LINE' });
					})
					.catch(error => {
						this.$sf_toast({ type: 'error', message: error.message });
					});
			}
		},

		shopCd() {
			this.$sf_toggleLoading(true);
			this.getStnCd_({ plantCd: this.plantCd, shopCd: this.shopCd })
				.then(header => {
					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,

		onChange({ key, value }) {
			this[key] = value;
		},

		search() {
			this.$sf_toggleLoading(true);
			this.select_({ plantCd: this.user.plantCd, shopCd: this.shopCd, stnCd: this.stnCd, currentPage: 1, pageUnit: this.stations.pageUnit })
				.then(header => {
					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	}
};
</script>

<style></style>
